import React from 'react';

const Description = () => {
    return (
        <div>
            <section className='mt-5 bg-danger '>
                <p className='text-wrap justify-content-start text-white fw-bolder' ><span className='bg-dark bg-gradient'>Dr. Max </span> believes in a holistic dental practice that is more preventive in nature. This includes the promotion of a healthy lifestyle and the incorporation of proper dental hygiene in your everyday life. By using this preventive approach, the good doctor makes sure that all her patients are 100% satisfied during the course of their visits.Our aim is to deliver oral health care of the highest standard to our patients through experienced dental surgeons and modern technology. The department provides diagnosis, management and surgical treatment of defects and injuries related to the function and aesthetics of the teeth, gums and jaws. It also provides excellent surgical service for all sorts of maxillofacial surgery & disease.</p>
            </section>

        </div>
    );
};

export default Description;
<section>
    <h6>If you’re looking for more intensive care for your teeth, then you’ll be happy to know that Dr. Sheri Yadav is available to help you get your smile perfect as well. Her expertise in the following branches of dentistry has left countless patients satisfied over the course of her long career.</h6>
</section>